import { useContext } from "react";
import { DisabledFormContext } from "../components/DisabledFormContext";

export default function useDisabled(propsDisabled: boolean | undefined) {
    const ctx = useContext(DisabledFormContext);
    return propsDisabled ?? ctx;
}
